import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk';
import { WINDOW } from '@ng-web-apis/common';
import { StorageService } from '@services';
import { PersonalisationToken, SegmentId } from '@types';
import { CookieService } from 'ngx-cookie-service';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ft-us-servicing-temp-user-utility-bar',
  templateUrl: './us-servicing-temp-user-utility-bar.component.html',
  styleUrls: ['./us-servicing-temp-user-utility-bar.component.scss'],
})
export class UsServicingTempUserUtilityBarComponent
  implements OnInit, OnDestroy {
  private isPRC = false;
  private isComingFromPRC = false;
  public brLabels: object = {};
  private host = '.franklintempleton.com';
  private isErrorPage = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  public showUserBar = false;

  constructor(
    private cookieService: CookieService,
    private storageService: StorageService,
    @Inject(WINDOW) readonly windowRef: Window
  ) {
    if (this.windowRef.location.hostname === 'localhost') {
      this.host = 'localhost';
      return;
    }
    this.host =
      this.windowRef.location.hostname.indexOf('en-us') > -1
        ? '.ftsites.com'
        : '.franklintempleton.com';
  }

  ngOnInit() {
    from(this.storageService.getIdentityToken())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((token) => {
        this.isErrorPage =
          this.windowRef.location.search === '?bypass=partner-edward-jones' &&
          token === '';
        this.isComingFromPRC = this.cookieService.check(
          'restored-ft-identity-token'
        );
        this.isPRC =
          this.windowRef.location.pathname.indexOf('service-center') > -1;

        this.showUserBar =
          !this.isPRC && this.isComingFromPRC && !this.isErrorPage;
      });
  }

  populate(config: any, labels: any, component: BrComponent, page: Page): void {
    this.brLabels = labels;
  }

  public prcLinkHandler(): void {
    let redirectTo = '/';
    const sessionCookie = this.cookieService.get(
      'restored-ft-identity-token'
    ) as PersonalisationToken;
    const segment$ = from(this.storageService.retrieve('segment_en-us'));

    segment$.pipe(takeUntil(this.unsubscribe$)).subscribe((segment) => {
      if (segment !== SegmentId.FINANCIAL_PROFESSIONALS) {
        redirectTo = '/?role=fp';
      }
      if (sessionCookie) {
        this.storageService.setIdentityToken(sessionCookie);
      }
      this.cookieService.delete(
        'restored-ft-identity-token',
        '/',
        this.host,
        true
      );
      this.windowRef.location.assign(redirectTo);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
